import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import liffUtil from './liffUtil'
import utils from './utils'
import validator from './plugins/validator'
import Notifications from 'vue-notification'

import axios from './axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
const plugin = {
    install (Vue) {
        Vue.prototype.$validator = validator
        Vue.prototype.$liffUtil = liffUtil
        Vue.prototype.$utils = utils
    }
}
Vue.use(plugin)
Vue.use(Notifications)
Vue.use(VueAxios, axios)

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')
